import jsonschema from 'jsonschema';

export function isValidJsonOptions(value, schemaJson) {
  if (typeof value !== 'string') return false;
  const Validator = jsonschema.Validator;
  return new Validator().validate(value, schemaJson).valid;
}
